import React, { useState } from "react";

const SuggestionForm = () => {
  const [form, setForm] = useState({
    title: "",
    category: "",
    description: "",
  });

  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState({ message: "", type: "" });

  const categories = [
    "Gameplay",
    "Plugins",
    "Events",
    "Community",
    "Server Performance",
    "Other",
  ];

  const validate = () => {
    const newErrors = {};
    if (!form.title.trim()) newErrors.title = "Title is required";
    if (!form.category) newErrors.category = "Please select a category";
    if (!form.description.trim())
      newErrors.description = "Description cannot be empty";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const webhookURL =
      "https://discord.com/api/webhooks/1375128404201963521/_XhKIbM6hZYTWNFl1e1SnNJIzN0ZFVBpkiQMI_sLjDQqCODhzZlLBnWvGVU1GwXq6L3w";

    const embed = {
      embeds: [
        {
          title: "💡 New Suggestion Submitted",
          color: 0x43aa8b,
          fields: [
            { name: "Title", value: form.title || "N/A" },
            { name: "Category", value: form.category || "N/A" },
            { name: "Description", value: form.description || "N/A" },
          ],
          footer: {
            text: "RixxyMC Suggestion Form",
          },
          timestamp: new Date().toISOString(),
        },
      ],
    };

    try {
      const response = await fetch(webhookURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(embed),
      });

      if (!response.ok) throw new Error("Failed to submit suggestion");

      setStatus({ message: "✅ Thank you for your suggestion!", type: "success" });
      setForm({ title: "", category: "", description: "" });
      setErrors({});
    } catch (error) {
      setStatus({
        message: "❌ Submission failed. Please try again later.",
        type: "error",
      });
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Suggestion Form</h2>

      {status.message && (
        <p
          style={{
            ...styles.success,
            color: status.type === "success" ? "#4CAF50" : "#ff6b6b",
          }}
        >
          {status.message}
        </p>
      )}

      <form onSubmit={handleSubmit} noValidate style={styles.form}>
        <label style={styles.label}>
          Suggestion Title:
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleChange}
            style={styles.input}
            placeholder="Enter a brief title"
          />
          {errors.title && <p style={styles.error}>{errors.title}</p>}
        </label>

        <label style={styles.label}>
          Category:
          <select
            name="category"
            value={form.category}
            onChange={handleChange}
            style={styles.select}
          >
            <option value="">-- Select category --</option>
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
          {errors.category && <p style={styles.error}>{errors.category}</p>}
        </label>

        <label style={styles.label}>
          Description:
          <textarea
            name="description"
            value={form.description}
            onChange={handleChange}
            style={styles.textarea}
            placeholder="Describe your suggestion in detail"
            rows={6}
          />
          {errors.description && <p style={styles.error}>{errors.description}</p>}
        </label>

        <button type="submit" style={styles.button}>
          Submit Suggestion
        </button>
      </form>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "600px",
    margin: "2rem auto",
    padding: "1.5rem",
    backgroundColor: "rgba(20, 20, 40, 0.85)",
    borderRadius: "12px",
    color: "#f0f0f0",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.7)",
  },
  title: {
    textAlign: "center",
    fontSize: "2rem",
    marginBottom: "1rem",
    background: "linear-gradient(90deg, #90be6d, #43aa8b)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: "900",
  },
  success: {
    textAlign: "center",
    marginBottom: "1rem",
    fontWeight: "bold",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  label: {
    display: "flex",
    flexDirection: "column",
    fontSize: "1rem",
    fontWeight: "600",
  },
  input: {
    marginTop: "0.3rem",
    padding: "0.5rem 0.75rem",
    borderRadius: "6px",
    border: "1px solid #555",
    backgroundColor: "#222",
    color: "#eee",
    fontSize: "1rem",
  },
  select: {
    marginTop: "0.3rem",
    padding: "0.5rem 0.75rem",
    borderRadius: "6px",
    border: "1px solid #555",
    backgroundColor: "#222",
    color: "#eee",
    fontSize: "1rem",
  },
  textarea: {
    marginTop: "0.3rem",
    padding: "0.5rem 0.75rem",
    borderRadius: "6px",
    border: "1px solid #555",
    backgroundColor: "#222",
    color: "#eee",
    fontSize: "1rem",
    resize: "vertical",
  },
  error: {
    color: "#ff6b6b",
    marginTop: "0.25rem",
    fontSize: "0.85rem",
    fontWeight: "600",
  },
  button: {
    marginTop: "1rem",
    padding: "0.75rem",
    borderRadius: "8px",
    border: "none",
    background: "linear-gradient(90deg, #90be6d, #43aa8b)",
    color: "#fff",
    fontSize: "1.1rem",
    fontWeight: "700",
    cursor: "pointer",
    transition: "background 0.3s ease",
  },
};

export default SuggestionForm;
